import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import EmailSignatureService from '../../services/EmailSignatureService';
import OauthApiService from '../../services/OauthService';
import SignatureService from '../../services/SignatureService';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/Loader/Loader';
import ThemeService from '../../services/ThemeService';
import { AuthContext } from '../../contexts/AuthContext';
import { AdditionalSignaturesFinalFlow } from '../../components/SignMethods/AdditionalSignaturesFinalFlow/AdditionalSignaturesFinalFlow';
import { ADDITIONAL_SIGNATURES_CONTEXT_KEY, AdditionalSignaturesContext } from '../../contexts/AdditionalSignaturesContext';
import { LOCATION_REQUIRED } from '../../constants/GeneralConstants';
import { DocumentError } from '../DocumentError/DocumentError';

export const AOCValidCallback = () => {
  const [error, setError] = useState(null);
  const [emailId, setEmailId] = useState(null);
  const [completeAdditionalSignaturesFlow, setCompleteAdditionalSignaturesFlow] = useState(false);
  const { setDocumentData } = useContext(AdditionalSignaturesContext);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const { setIsAuthenticated } = useContext(AuthContext);

  const getStateParams = () => {
    const windowUrl = window.location.search;
    const querystring = new URLSearchParams(windowUrl);

    let state = querystring.get("state");

    if (!state) {
      localStorage.removeItem(ADDITIONAL_SIGNATURES_CONTEXT_KEY);
      setError(t("general.error") + ". URL: " + window.location.href);
      return;
    }

    const decodedState = atob(state);

    const paramsArray = decodedState.split(',');

    return paramsArray;
  }

  useEffect(() => {
    const windowUrl = window.location.search;
    const querystring = new URLSearchParams(windowUrl);
    const code = querystring.get("code");

    if (!code) {
      setError(t("general.error") + ". URL: " + window.location.href);
      return;
    }

    const [emailId] = getStateParams();
    setEmailId(emailId);

    OauthApiService.getToken((emailId))
      .then(() => {
        ThemeService.setTheme(emailId);
        SignatureService.pendingSignatures(emailId)
          .then(async (signaturesResponse) => {
            const document = signaturesResponse.data[0];
            const locationRequired = document.SignerDTO.LocationRequired;
            localStorage.setItem(LOCATION_REQUIRED, locationRequired);
            const body = {
              code
            };

            // Save data for additional signatures flow
            setDocumentData(document);

            EmailSignatureService.sendAOCValidCode(emailId, body)
              .then(() => {
                // Allow navigation to next view
                setIsAuthenticated(true);

                let link = "/sign";

                const signerDTO = document?.SignerDTO;
                const signatureBoxes = signerDTO?.SignatureBoxes;
                const isSignatureBoxesFlow = !!signatureBoxes;

                if (document.SignerDTO.AttachIdDocImages) {
                  link = "/attach-images";
                } else {
                  if (isSignatureBoxesFlow) return setCompleteAdditionalSignaturesFlow(true);
                }

                navigate(link, {
                  state: {
                    documents: document,
                    emailId,
                    otpCode: ''
                  }
                });
              })
              .catch((e) => {
                localStorage.removeItem(ADDITIONAL_SIGNATURES_CONTEXT_KEY);
                console.log(e);
                const statusCode = e?.response?.status;
                if (statusCode === 400) {
                  setError(t("general.error"));
                  return;
                }
                if (statusCode === 401) {
                  setError(t("general.error"));
                  return;
                }
                setError(t("general.error"));
              })
          })
          .catch((e) => {
            localStorage.removeItem(ADDITIONAL_SIGNATURES_CONTEXT_KEY);
            console.log(e);
            const statusCode = e?.response?.status;
            if (statusCode === 400) {
              setError(t("general.error"));
              return;
            }
            if (statusCode === 401) {
              setError(t("general.error"));
              return;
            }
            setError(t("general.error"));
          })
      })
      .catch((e) => {
        localStorage.removeItem(ADDITIONAL_SIGNATURES_CONTEXT_KEY);
        console.log(e);
        const statusCode = e?.response?.status;
        if (statusCode === 400) {
          setError(t("general.error"));
          return;
        }
        if (statusCode === 401) {
          setError(t("general.error"));
          return;
        }
        setError(t("general.error"));
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>
    {error && <DocumentError />}
    {!error && <Loader />}
    {completeAdditionalSignaturesFlow && <AdditionalSignaturesFinalFlow emailId={emailId} />}
  </>;
}
